import React from 'react';

export default ({ color = '#221CB6', size = 12 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_29095_473)">
      <path
        d="M3.25 1.75L4.1924 2.73809C4.50233 3.06305 4.64521 3.5127 4.57971 3.95695C4.5174 4.37954 4.27289 4.75354 3.91079 4.98014L3.826 5.0332C3.07952 5.50035 2.82241 6.46585 3.23772 7.24235L3.28793 7.33625C3.62326 7.96325 3.55532 8.7293 3.11491 9.2875L2.75 9.75"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 1C5.7432 2.78252 7.36245 4.74251 9.75 2.75"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9 5C10.4367 2.71776 8.41895 1 6 1C3.23857 1 1 3.23857 1 6C1 8.6776 3.10472 10.8636 5.75 10.9938"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.20117 8.3983L8.40117 9.5983L10.8012 7.1983"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_29095_473">
        <rect width={size} height={size} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
